import { render } from "./CataloguePage.vue?vue&type=template&id=3b78e621"
import script from "./CataloguePage.vue?vue&type=script&lang=js"
export * from "./CataloguePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__